__turbopack_context__.v({
  "className": "fraunces_739ff439-module__VOzesq__className",
});
